const AUTH_BYPASS_ENABLED = false;
const TEMP_AUTH_TOKEN = 'temp-auth-token';
const TEMP_AUTH_USER_ID = 'demo-user';

function ensureTemporaryAuthSession() {
  if (typeof window === 'undefined' || !AUTH_BYPASS_ENABLED) {
    return '';
  }

  const existingToken = window.localStorage.getItem('olympusMons');
  if (existingToken) {
    return existingToken;
  }

  window.localStorage.setItem('olympusMons', TEMP_AUTH_TOKEN);
  window.localStorage.setItem('use', TEMP_AUTH_USER_ID);
  return TEMP_AUTH_TOKEN;
}

export function isAuthSessionActive() {
  if (typeof window === 'undefined') {
    return false;
  }
  if (AUTH_BYPASS_ENABLED) {
    return Boolean(ensureTemporaryAuthSession());
  }
  return window.localStorage.getItem('olympusMons');
}

export function isTemporaryAuthBypassEnabled() {
  return AUTH_BYPASS_ENABLED;
}

export function clearAuthSession() {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.removeItem('olympusMons');
  window.localStorage.removeItem('use');
  window.localStorage.removeItem('email');
}
